import * as React from 'react'
import clsx from 'clsx'
import './index.scss'

/**
 * 马甲站 Contact 表单选择字段（对齐原型 contact-sheet 底部弹层选择器）。
 * 替代 react-select 的内联下拉：点击 control 从底部滑出选项 sheet，
 * 选中项左侧带勾选标记。仅 vest 分支使用，非 vest 仍走 react-select。
 *
 * 只负责「展示当前值 + 弹层选择」，级联/校验/refetch 等副作用留在父级 onSelect。
 */
export interface VestSelectOption {
  value: any
  label: string
}

export interface VestSelectSheetProps {
  /** 当前选中项（RHF field.value，形如 { value, label }） */
  value?: VestSelectOption
  /** sheet 标题（与字段 label 一致，如 Feedback type / Classification） */
  title: string
  /** 未选中时占位文案 */
  placeholder?: string
  options: VestSelectOption[]
  isError?: boolean
  /** 数据加载中：禁用点击 */
  loading?: boolean
  onSelect: (option: VestSelectOption) => void
}

const VestSelectSheet: React.FC<VestSelectSheetProps> = ({
  value,
  title,
  placeholder,
  options,
  isError,
  loading,
  onSelect
}) => {
  const [open, setOpen] = React.useState(false)
  const hasValue = Boolean(value && value.label != null && value.label !== '')

  const close = () => setOpen(false)

  return (
    <div className={clsx('vest-select', isError && 'is-error')}>
      <button
        type='button'
        className={clsx('vest-select__control', open && 'is-open')}
        disabled={loading}
        onClick={() => setOpen(true)}
      >
        <span
          className={clsx(
            'vest-select__value',
            !hasValue && 'vest-select__value--placeholder'
          )}
        >
          {hasValue ? value?.label : placeholder}
        </span>
        <i className='vest-select__chevron' aria-hidden='true' />
      </button>

      {open && (
        <div className='vest-select-sheet-layer'>
          <button
            type='button'
            className='vest-select-sheet-layer__mask'
            aria-label='Close selector'
            onClick={close}
          />
          <section className='vest-select-sheet'>
            <header className='vest-select-sheet__header'>
              <h2>{title}</h2>
              <button
                type='button'
                className='vest-select-sheet__close'
                aria-label='Close'
                onClick={close}
              />
            </header>
            <div className='vest-select-sheet__list'>
              {options.map((option) => {
                const selected = hasValue && value?.value === option.value
                return (
                  <button
                    type='button'
                    key={String(option.value)}
                    className={clsx(
                      'vest-select-sheet__option',
                      selected && 'is-selected'
                    )}
                    aria-pressed={selected}
                    onClick={() => {
                      onSelect(option)
                      close()
                    }}
                  >
                    <span>{option.label}</span>
                  </button>
                )
              })}
            </div>
          </section>
        </div>
      )}
    </div>
  )
}

export default VestSelectSheet
